export default __webpack_public_path__ + "static/FiraMono-Medium-0b1297fa7ffafe7d3415aa68bc9b7f6d.woff2";